import { config } from 'zod';

/**
 * İçerik güvenlik politikası (O17; faz-2 S15 başlık tablosu): `script-src 'self'`, `unsafe-eval` yoktur. zod'un JIT
 * derleyicisi ilk nesne şeması kurulurken `new Function` dener; hata yakalansa da tarayıcı denemeyi CSP ihlali olarak
 * bildirir (`securitypolicyviolation`, S15-K4). JIT kapatılır: şemalar derlenmeden doğrulanır, sonuç aynıdır.
 *
 * Ayar şema kurulurken okunur: bu modül girişin (main.tsx) ilk içe aktarımıdır ve şema kuran her modülden önce
 * değerlendirilir. Paketin geri kalanı girişe çekilmez; yalnız `config` gelir.
 */
config({ jitless: true });
